module.exports = {
  adsetPublicUrl: 'https://adset.apester.local.com',
  analyticsBaseUrl: 'https://analytics.apester.local.com',
  usersBaseUrl: 'https://users.apester.local.com',
  interactionBaseUrl: 'https://interaction.apester.local.com',
  consoleBaseUrl: 'https://console.apester.local.com',
  editorBaseUrl: 'https://editor.apester.local.com',
  campaignBaseUrl: 'https://campaign.apester.local.com',
  campaignApiPublicUrl: 'https://campaign-api.apester.local.com',
  adsetApiPublicUrl: 'https://adset-api.apester.local.com',
  authBaseUrl: 'https://authorization.apester.local.com',
  eventsPublicUrl: 'https://events.apester.com',
  imagesUrl: '//img.stg.apester.dev',
  imagesNewUrl: '//img.stg.apester.dev',
  staticBucket: '//static.stg.apester.dev',
  vreminiUrl: 'https://vremini.apester.local.com',
  playerBaseUrl: 'https://player.apester.local.com/v2/',
  rendererBaseUrl: 'https://renderer.apester.local.com/interaction/',
  planApiUrl: 'https://plans-api.apester.local.com',
  portalUrl: 'https://portal.apester.local.com',
  jobsUrl: 'https://jobs-api.apester.local.com',
  paymentsUrl: 'https://payments.apester.local.com',
  wixIntegrationUrl: 'https://wix-integration.apester.local.com',
  stripePK: 'pk_test_bvf99QAfxY3req0tNMAx4HXK00pvJyS0NK',
  webhooksBaseUrl: 'https://webhooks.apester.local.com',
  enableHeap: false,
};
